import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Cabcompaniesinmumbai() {



const cardData = {
  keyword: " Cab Companies in Mumbai",

headingDescription:
  "Omshree Cab offers dependable and professional cab services in Mumbai, making it one of the trusted options among cab companies in the city. Whether travelers need transportation for airport transfers, city rides, business travel, sightseeing, or outstation trips, our cab service ensures a comfortable and hassle-free journey. Mumbai has hundreds of taxi providers ranging from local operators to large app-based platforms, showing the high demand for cab transportation in the city. Our services include flexible booking options such as one-way rides, round trips, hourly rentals, and full-day packages with transparent pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for individuals, families, and corporate groups. With experienced drivers, punctual pickups from any location in Mumbai, and 24/7 customer support, Omshree Cab stands among the reliable cab companies providing safe and comfortable travel across Mumbai.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of the most famous landmarks in Mumbai and a major attraction for tourists visiting the city. The historic arch monument overlooking the Arabian Sea was built during the British era and remains one of the most photographed locations in Mumbai. Visitors come here to admire the architecture, enjoy the sea view, and take ferry rides to Elephanta Island. The surrounding Colaba area is filled with cafes, hotels, and local markets that attract travelers throughout the day. Many cab companies in Mumbai provide convenient rides to this iconic destination, allowing tourists to explore South Mumbai comfortably without worrying about traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road that stretches along the Arabian Sea and is one of the most beautiful locations in Mumbai. The curved boulevard is famously known as the Queen’s Necklace because the streetlights create a sparkling necklace shape when viewed at night. Visitors come here for evening walks, relaxation, and breathtaking sunset views. The long promenade offers a peaceful escape from the busy city environment. Taxi services and cab companies frequently operate along this route, allowing travelers to enjoy a comfortable ride while exploring nearby attractions in South Mumbai."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of the most popular beaches in Mumbai and attracts thousands of visitors every day. Families, tourists, and locals visit the beach to enjoy the sea breeze, relax on the sandy shore, and taste famous Mumbai street foods like pav bhaji, bhel puri, and pani puri. The beach becomes especially lively during the evening when people gather to watch the sunset and spend time with friends and family. Many cab companies provide easy transportation to Juhu Beach, making it convenient for travelers to reach the area comfortably from different parts of the city."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is one of the most revered temples in Mumbai dedicated to Lord Ganesha. Devotees from across India visit the temple to seek blessings and offer prayers throughout the year. The temple is known for its spiritual atmosphere and beautiful architecture, attracting both pilgrims and tourists. Festivals such as Ganesh Chaturthi bring large crowds to the temple. Cab services in Mumbai often provide convenient travel options for visitors who wish to reach the temple comfortably and avoid the challenges of parking and crowded public transport."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is one of Mumbai’s most impressive engineering landmarks connecting Bandra and Worli across the Arabian Sea. The cable-stayed bridge offers breathtaking views of the ocean and city skyline, making it a memorable route for travelers. Driving across the sea link is a unique experience, especially during sunset or nighttime when the bridge lights create a beautiful atmosphere. Many cab companies in Mumbai include this route in city tours and sightseeing drives because it showcases the modern infrastructure of the city."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous Islamic shrine located on a small island off the coast of Mumbai. The white marble structure stands gracefully in the Arabian Sea and is connected to the mainland by a narrow walkway visible during low tide. People from different religions visit the shrine to offer prayers and experience the peaceful spiritual environment. The location also provides stunning sea views that attract tourists and photographers. Taxi services make it convenient for visitors to reach this unique landmark located along the busy Mumbai coastline."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut caves located on Elephanta Island in Mumbai Harbour and are known for their impressive sculptures dedicated to Lord Shiva. The caves are recognized as a UNESCO World Heritage Site and attract history lovers and tourists from around the world. Visitors typically take a ferry from the Gateway of India to reach the island and explore the cave temples and carvings. Cab companies in Mumbai often provide rides to the ferry point, making it easy for travelers to start their journey to this historic destination."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large forest reserve located within Mumbai city and offers a refreshing escape from the busy urban environment. The park covers a vast area of greenery and is home to wildlife, nature trails, and the ancient Kanheri Caves carved by Buddhist monks centuries ago. Visitors enjoy trekking, cycling, and exploring the historical caves inside the park. Cab services provide convenient transportation to the park, allowing travelers to reach this natural retreat easily from different parts of Mumbai."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is one of Mumbai’s most vibrant shopping streets and a favorite destination for tourists who enjoy street markets and local culture. The market is filled with stalls selling clothes, accessories, jewelry, handicrafts, and souvenirs at affordable prices. Visitors can also explore nearby cafes and restaurants that offer a mix of local and international cuisines. Many cab companies operate frequently in this area because it is close to major attractions like the Gateway of India and Marine Drive."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraced gardens located on Malabar Hill in Mumbai. The gardens offer panoramic views of Marine Drive and the Arabian Sea, making them a peaceful place to relax and enjoy nature. Visitors often come here for morning walks, photography, and enjoying the calm atmosphere away from the busy city streets. Taxi services make it easy for tourists to reach this elevated location and include it as part of a Mumbai sightseeing tour."
  }
],



services: [
{
name: "Cab Companies in Mumbai",
description: "Cab companies in Mumbai provide reliable transportation services for local travel, airport transfers, and outstation journeys. These companies operate fleets of AC sedans, SUVs, and premium vehicles designed for comfortable city travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for daily commuting, tourism visits, and corporate travel. Spacious interiors ensure comfortable seating for passengers during the journey. Flexible booking options allow easy ride scheduling anytime. Trusted cab companies ensure smooth and dependable travel experiences."
},
{
name: "Taxi Companies in Mumbai",
description: "Taxi companies in Mumbai offer convenient transportation for passengers traveling within the city or to nearby destinations. Their fleets include comfortable AC taxis suitable for city roads and highway travel. Experienced drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from residential areas, offices, hotels, and airport terminals. Ideal for daily commuting, airport transfers, and sightseeing trips. Spacious seating ensures comfortable travel for passengers. Flexible booking options allow passengers to schedule rides easily. Reliable taxi companies ensure safe and professional transportation."
},
{
name: "Cab Service Providers Mumbai",
description: "Cab service providers in Mumbai offer organized transportation solutions for individuals, families, and corporate travelers. Their fleets include modern AC sedans and SUVs suitable for local and intercity travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for business travel, tourism trips, and daily commuting. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow easy ride reservations. Reliable cab service providers ensure smooth transportation services."
},
{
name: "Taxi Operators Mumbai",
description: "Taxi operators in Mumbai provide dependable transportation services for passengers traveling across the city. Their fleets include AC taxis suitable for both short-distance and long-distance travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and daily commuting. Spacious interiors ensure comfortable travel during the journey. Flexible ride scheduling allows passengers to plan trips easily. Reliable taxi operators ensure smooth and efficient transportation."
},
{
name: "Best Cab Company Mumbai",
description: "Best cab company in Mumbai offers high-quality transportation services for passengers seeking reliable and comfortable travel. Their fleets include modern AC sedans and SUVs designed for city and highway travel. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Mumbai including homes, offices, hotels, and airports. Ideal for corporate travel, tourism visits, and airport transfers. Comfortable seating ensures relaxed journeys for passengers. Flexible booking options allow easy ride scheduling. Trusted cab companies ensure dependable travel experiences."
},
{
name: "Top Taxi Companies Mumbai",
description: "Top taxi companies in Mumbai provide professional transportation services for passengers across the city. Their fleets include well-maintained AC taxis suitable for daily commuting and airport transfers. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and personal trips. Spacious interiors ensure comfortable seating for passengers. Flexible ride scheduling allows convenient travel planning. Reliable taxi companies ensure smooth transportation services."
},
{
name: "Reliable Cab Company Mumbai",
description: "Reliable cab company in Mumbai provides dependable transportation services for passengers traveling across the city and nearby destinations. Their fleets include comfortable AC sedans and SUVs designed for safe travel. Professional drivers ensure punctual pickup and smooth driving experiences. Pickup services are available across Mumbai including homes, offices, hotels, and airports. Ideal for corporate travel, tourism visits, and airport transfers. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow easy ride scheduling. Trusted cab companies ensure reliable transportation services."
},
{
name: "Affordable Cab Companies Mumbai",
description: "Affordable cab companies in Mumbai offer budget-friendly transportation services for passengers seeking economical travel options. Their fleets include AC sedans and compact cars suitable for comfortable city travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across residential areas, offices, hotels, and airport terminals. Ideal for daily commuters, students, and budget travelers. Comfortable interiors ensure relaxed journeys during travel. Flexible booking options allow convenient ride scheduling. Affordable cab companies ensure economical and reliable transportation."
},
{
name: "Professional Cab Operators Mumbai",
description: "Professional cab operators in Mumbai provide organized transportation services for business travelers and tourists. Their fleets include well-maintained AC sedans and SUVs designed for comfortable city travel. Experienced drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for corporate travel, tourism visits, and daily commuting. Spacious seating ensures comfortable journeys for passengers. Flexible ride scheduling allows convenient travel planning. Reliable cab operators ensure professional transportation services."
},
{
name: "Cab Booking Companies Mumbai",
description: "Cab booking companies in Mumbai offer convenient digital platforms for passengers to reserve rides quickly and easily. Their fleets include AC sedans, SUVs, and premium vehicles suitable for city and outstation travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for business travel, tourism visits, and daily commuting. Spacious interiors ensure comfortable seating during travel. Flexible booking options allow instant ride confirmation. Reliable cab booking companies ensure smooth and hassle-free transportation."
}
],

tableData: [
["Cab Companies in Mumbai","Taxi Companies in Mumbai"],
["Cab Service Providers Mumbai","Taxi Operators Mumbai"],
["Best Cab Company Mumbai","Top Taxi Companies Mumbai"],
["Reliable Cab Company Mumbai","Affordable Cab Companies Mumbai"],
["Professional Cab Operators Mumbai","Cab Booking Companies Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Mumbai City Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in navigating Mumbai’s busy roads, traffic patterns, and local routes. They ensure passengers reach their destination safely and on time whether it is a local ride, airport transfer, or outstation journey."
  },
  {
    WhyChooseheading: "Transparent Taxi Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for cab services in Mumbai. We clearly explain per-kilometer fares, travel packages, and additional charges before confirming the booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our cab service operates 24/7 across Mumbai. Whether you need an early morning airport ride, late-night travel, or emergency transportation, Omshree Cabs is always available."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable ride for passengers."
  },
  {
    WhyChooseheading: "Flexible Travel Services",
    WhyChoosedescription: "We offer a wide range of cab services including local city rides, airport transfers, outstation travel, corporate transport, and special event transportation."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for individuals, families, and business travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and airports across Mumbai, making travel simple and hassle-free."
  },
  {
    WhyChooseheading: "Trusted Cab Company in Mumbai",
    WhyChoosedescription: "Omshree Cabs is trusted by many customers for reliable taxi services in Mumbai. Our punctual drivers, comfortable vehicles, and professional support ensure a stress-free travel experience."
  }
]
};

const faqData = [
  { question: "What types of cab services are available in Mumbai?", answer: "Omshree Cabs provides local taxi services, airport transfers, outstation cabs, corporate transportation, and hourly rental services." },
  { question: "Is cab service available 24 hours in Mumbai?", answer: "Yes, Omshree Cabs offers 24/7 taxi service across Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "Can I book a cab for Mumbai Airport transfer?", answer: "Yes, we provide reliable airport pickup and drop services for both Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "Which vehicles are available for booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your travel needs." },
  { question: "Do you provide outstation cab services from Mumbai?", answer: "Yes, Omshree Cabs provides outstation travel to destinations like Pune, Lonavala, Nashik, Surat, and many more cities." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak hours, weekends, and festival seasons." },
  { question: "Do you provide corporate cab services in Mumbai?", answer: "Yes, we provide corporate transportation solutions for business meetings, employee travel, and airport transfers." },
  { question: "Can I book a cab online?", answer: "Yes, customers can easily book a cab online or through phone for quick confirmation." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "Omshree Cabs is one of the most reliable cab companies in Mumbai. The driver arrived on time and the car was very clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "I booked Omshree Cabs for airport transfer in Mumbai and the experience was excellent. Smooth ride, professional driver, and transparent pricing.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Companies in Mumbai",
  "description": "Omshree Cab is one of the top cab companies in Mumbai offering reliable and professional taxi services. Book cabs from trusted cab operators for local travel, airport transfers, outstation trips, and corporate travel. Affordable fares and easy online cab booking across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4200"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Cab Companies in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab is a leading cab company in Mumbai providing reliable local, airport, outstation, and corporate taxi services. Affordable fares and easy online booking from professional cab operators." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabcompaniesinmumbai;